<template>
  <div
    class="
      flex flex-col
      overflow-hidden
      border-2
      shadow-lg
      rounded-xl
      tmsk-blue-border
    "
    @click="onClick"
  >
    <div v-if="$slots.header" class="flex-shrink-0 p-6 pb-0">
      <slot name="header" />
    </div>
    <div
      v-if="$slots.body"
      class="flex flex-col justify-center flex-1 p-6 bg-white"
    >
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  components: {},
  mixins: [],
  props: {
    onClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
}
</script>

<style scoped>
</style>
